<template>
  <div style="width: 100%">
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center flex-grow-1"
      style="height: 500px"
    >
      <v-progress-circular indeterminate color="primary" size="60">
      </v-progress-circular>
    </div>

    <div v-else>
      <!-- map -->
      <!-- map -->
      <!-- map -->
      <div class="content" :style="mtop">
        <div id="wrapper">
          <div id="google_map">
            <GmapMap
              :center="{
                //todo lesbos LatLng
                lat: 39.167626,
                lng: 26.211931,
              }"
              :zoom="9"
              :options="mapOptions"
              class="googleMap"
              ref="mapRef"
            >
              <GmapMarker
                v-for="(poi, i) in pois"
                :key="poi.id"
                :position="{
                  lat: poi.latitude,
                  lng: poi.longitude,
                }"
                :clickable="true"
                :draggable="false"
                :label="
                  startRoute
                    ? {
                        text: (i + 1).toString(),
                        color: 'white',
                        fontWeight: 'bold',
                      }
                    : ''
                "
                :icon="categoryIconMatcher(poi)"
              >
              </GmapMarker>

              <gmap-custom-marker
                :marker="{ lat: location.latitude, lng: location.longitude }"
                v-if="hasLocation"
              >
                <v-icon
                  color="blue"
                  class="rounded-circle pulse-button"
                  size="15"
                  >mdi-circle</v-icon
                >
              </gmap-custom-marker>
            </GmapMap>
          </div>

          <div id="return-button">
            <div
              class="secondary rounded-pill px-2 d-flex align-center"
              @click="$router.push(`/${path}`)"
            >
              <v-btn icon>
                <v-icon color="white">mdi-arrow-left-thin</v-icon>
              </v-btn>

              <span class="body-2 white--text pr-1">
                {{ path == "pois" ? $t("pois.title") : $t("routes.title") }}
              </span>
            </div>
          </div>

          <div id="start-button">
            <div class="d-flex flex-column align-center" id="map-controls">
              <v-btn
                v-if="path == 'routes'"
                icon
                class="secondary mb-2 white--text rounded-circle"
                :class="startRoute ? '' : 'pulse-button-start'"
                @click="getRoute"
                :loading="locationLoader"
                large
              >
                <v-icon color="white">mdi-flag-triangle</v-icon>
              </v-btn>
              <v-btn
                icon
                class="secondary mb-2 white--text"
                @click="recenter"
                :loading="locationLoader"
              >
                <v-icon color="white">mdi-crosshairs-gps</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- map -->
      <!-- map -->
      <!-- map -->

      <!-- Details -->
      <!-- Details -->
      <!-- Details -->
      <!-- Details -->

      <div class="page-body" :style="path == 'routes' ? 'top: 75%' : 'top:77%'">
        <v-btn
          height="25px"
          width="25px"
          icon
          class="white rounded-0 chevron-button pa-4"
          @click="$vuetify.goTo(500, options)"
        >
          <v-icon class="px-2" color="secondary" size="25"
            >mdi-chevron-up</v-icon
          >
        </v-btn>

        <div class="d-flex flex-column px-4 py-2 white">
          <div class="d-flex align-center justify-space-between mb-2">
            <div
              v-if="path == 'routes'"
              class="body-1 secondary--text text--darken-2"
              style="width: 235px"
            >
              {{ route.name }}
              <div
                class="body-1 secondary--text text--darken-2 font-weight-bold"
              >
                {{ distance }}
              </div>
            </div>

            <div
              class="d-flex align-center"
              :style="path == 'routes' ? '' : 'width: 100%'"
            >
              <div class="inner ml-auto mr-7">
                <div
                  style="width: 100%"
                  class="d-flex align-center justify-center"
                >
                  <v-btn icon @click="openAr">
                    <v-icon color="secondary" class="rounded-circle" size="40">
                      mdi-cube-scan
                    </v-icon>
                  </v-btn>
                </div>
              </div>

              <v-icon
                @click="getDirections"
                size="35"
                class="ml-auto"
                color="secondary"
                >mdi-directions</v-icon
              >
            </div>
          </div>
          <v-divider class="mb-4 mt-1"></v-divider>

          <!-- poi change -->
          <div class="d-flex align-center justify-center mb-4" ref="title">
            <div
              class="d-flex align-center justify-center px-2 flex-grow-1"
              ref="startPageHeight"
            >
              <v-btn
                v-if="path == 'routes'"
                icon
                :disabled="currentPoi.id == pois[0].id"
                @click="previousPoi"
              >
                <v-icon color="secondary " size="35">mdi-skip-previous</v-icon>
              </v-btn>

              <v-avatar size="60" class="mr-4 ml-4">
                <img
                  :src="`https://efales.mobics.gr${currentPoi.main_image}`"
                  alt="center_image"
                />
              </v-avatar>
              <span class="body-1 secondary--text text--darken-2 mr-auto"
                >{{ currentPoi.name }}
              </span>

              <v-btn
                v-if="path == 'routes'"
                icon
                :disabled="currentPoi.id == pois[pois.length - 1].id"
                @click="nextPoi"
              >
                <v-icon color="secondary " size="35">mdi-skip-next</v-icon>
              </v-btn>
            </div>
          </div>

          <v-divider class="mb-4"></v-divider>

          <div class="d-flex flex-column align-self-start mb-8">
            <div
              class="body-1 secondary--text font-weight-bold text--darken-2 mb-2"
            >
              {{ $t("pois.gallery") }}
            </div>

            <v-divider
              class="mb-4 accent"
              style="padding-top: 2px; border-radius: 20%"
              width="35px"
            ></v-divider>

            <div class="d-flex flex-row flex-wrap mb-4" style="margin: 0 -16px">
              <div
                class="d-flex flex-column"
                style="position: relative; width: 50%"
                v-for="(image, i) in currentPoi.images"
                :key="image.id"
                @click="openDialog(currentPoi, image, i)"
              >
                <img
                  v-if="i < 4"
                  style="width: 100%; height: 150px"
                  :src="`https://efales.mobics.gr/images/${image.image[0].file_name}`"
                />
                <!-- <div
                  v-if="i < 4"
                  style="
                    position: absolute;
                    bottom: 0;
                    opacity: 0.8;
                    width: 100%;
                  "
                  class="secondary font-weight-bold white--text px-1"
                >
                  {{
                    decodeEntities(currentPoi.description).length > 18
                      ? decodeEntities(currentPoi.description).substring(
                          0,
                          19
                        ) + "..."
                      : decodeEntities(currentPoi.description)
                  }}
                </div> -->
              </div>
            </div>

            <div
              class="body-1 secondary--text font-weight-bold text--darken-2 mb-2"
            >
              {{ $t("pois.description") }}
            </div>

            <v-divider
              class="mb-4 accent"
              style="padding-top: 2px; border-radius: 20%"
              width="35px"
            ></v-divider>

            <div class="body-2" v-html="currentPoi.description"></div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      persistent
      v-model="dialog.open"
      max-width="100%"
      fullscreen
      style="z-index: 900 !important"
    >
      <CarouselModal v-if="dialog.open" :dialog="dialog" @close="closeDialog" />
    </v-dialog>
  </div>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
import { AppLauncher } from "@capacitor/app-launcher";

import axios from "axios";
import { gmapApi } from "vue2-google-maps";
import { mapState, mapActions, mapMutations } from "vuex";
import { decodeEntities } from "../utils/decodeEntities";
import CarouselModal from "./CarouselModal.vue";
import { Device } from "@capacitor/device";

// Icon fix

export default {
  components: {
    "gmap-custom-marker": GmapCustomMarker,
    CarouselModal,
  },

  async created() {
    try {
      this.loader = true;

      let res = null;
      if (this.path == "pois") {
        res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/pois/${this.$route.params.poi_id}`
        );

        this.pois.push({
          ...res.data.poi,
          latitude: parseFloat(res.data.poi.latitude),
          longitude: parseFloat(res.data.poi.longitude),
        });
      } else if (this.path == "routes") {
        res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/paths/${this.$route.params.route_id}`
        );

        this.pois = res.data.path.path_pois.map((poi) => {
          return {
            ...poi.poi,
            latitude: parseFloat(poi.poi.latitude),
            longitude: parseFloat(poi.poi.longitude),
          };
        });

        this.route = res.data.path;
      }
      await this.setCurrentPoi(this.pois[0].id);
      console.log(this.currentPoi);
      this.loader = false;
    } catch (e) {
      console.log(e);
    }
  },

  async destroyed() {
    await this.stop();
    await this.stopSearching();
  },

  mounted() {
    this.$nextTick(() => {
      this.map = this.$refs.mapRef;
    });
  },

  data() {
    return {
      map: null,
      route: null,
      currentPoi: null,
      pois: [],
      startRoute: false,
      locationLoader: false,
      loader: true,
      myLocationMarker: {},
      isPlaying: false,
      zoom: 13,
      start: false,
      distance: null,

      mapOptions: {
        directionsService: null,
        directionsRenderer: null,
        zoomControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        keyboardShortcuts: false,
        gestureHandling: "greedy",
      },

      options: {
        duration: 300,
        offset: 10,
        easing: "linear",
      },

      dialog: {
        open: false,
        poi: null,
        image: null,
        index: null,
      },
    };
  },

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,

      mobileLang: (state) => state.base.mobileLang,
      location: (state) => state.base.location,
    }),

    mtop() {
      return {
        margin: `${this.insets?.top}px 0px 0px 0px`,
      };
    },

    hasLocation() {
      return !!this.location;
    },

    path() {
      return this.$route.path.split("/")[1];
    },

    google: gmapApi,
  },

  methods: {
    ...mapActions(["searchBeacon", "stopSearching", "getLocation"]),
    ...mapMutations(["toggleSnackbar"]),
    categoryIconMatcher(poi) {
      switch (poi.category_id) {
        case 3:
          return { url: require("../assets/icons/oikies.png") };

        case 4:
          return { url: require("../assets/icons/ypodomes.png") };

        case 5:
          return { url: require("../assets/icons/iera.png") };

        case 6:
          return { url: require("../assets/icons/temenh.png") };

        case 7:
          return { url: require("../assets/icons/kastra.png") };

        case 8:
          return { url: require("../assets/icons/naoi.png") };

        case 9:
          return { url: require("../assets/icons/tonero.png") };

        default:
          return { url: require("../assets/icons/tonero.png") };
      }
    },
    async openAr() {
      const info = await Device.getInfo();
      if (info.platform == "ios") {
        const { value } = await AppLauncher.canOpenUrl({
          url: "efalesar://",
        });
        if (!value) {
          window.open(
            "https://apps.apple.com/us/app/ar-routes-of-lesbos/id6459830581"
          );
        }

        await AppLauncher.openUrl({
          url: "efalesar://",
        });
      } else if (info.platform == "android") {
        const { value } = await AppLauncher.canOpenUrl({
          url: "com.efalesar.app",
        });
        if (!value) {
          window.open(
            "https://play.google.com/store/apps/details?id=com.efalesar.app"
          );
        }
        await AppLauncher.openUrl({
          url: "com.efalesar.app",
        });
      }
    },

    async getRoute() {
      try {
        this.startRoute = true;
        const waypoints = this.pois
          .map((poi, i) => {
            if (i != 0 && i != this.pois.length - 1)
              return {
                location: {
                  lat: poi.latitude,
                  lng: poi.longitude,
                },
                stopover: true,
              };
          })
          .slice(1, -1);
        console.log(waypoints);

        const directionsService = new this.google.maps.DirectionsService();

        const directionsRenderer = new this.google.maps.DirectionsRenderer({
          suppressMarkers: true,
        });

        directionsRenderer.setMap(this.$refs.mapRef.$mapObject);

        directionsService
          .route({
            origin: {
              lat: this.pois[0].latitude,
              lng: this.pois[0].longitude,
            },
            destination: {
              lat: this.pois[this.pois.length - 1].latitude,
              lng: this.pois[this.pois.length - 1].longitude,
            },
            waypoints: waypoints,
            travelMode: this.google.maps.TravelMode.DRIVING,
          })
          .then((response) => {
            directionsRenderer.setDirections(response);
            console.log(response);
            let distance = 0;
            for (const leg of response.routes[0].legs) {
              distance += leg.distance.value;
            }
            this.distance = (distance / 1000).toFixed(1) + "km";
            this.setCurrentPoi(this.pois[0].id);
          })
          .catch((e) =>
            console.log("Directions request failed due to " + status)
          );
      } catch (e) {
        console.log(e);
      }
    },

    async recenter() {
      try {
        await this.getLocation();
        this.panTo(this.location.latitude, this.location.longitude);
      } catch (e) {
        console.log(e);
      }
    },

    getDirections() {
      window.open(
        `https://www.google.com/maps/dir/?api=1&origin=${this.location.latitude}, ${this.location.longitude}&destination=${this.currentPoi.latitude}, ${this.currentPoi.longitude}&travelmode=driving`
      );
    },

    async setCurrentPoi(id) {
      const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois/${id}`);
      this.currentPoi = {
        ...res.data.poi,
        latitude: parseFloat(res.data.poi.latitude),
        longitude: parseFloat(res.data.poi.longitude),
      };
      if (!this.startRoute) return;
      this.panTo(this.currentPoi.latitude, this.currentPoi.longitude);
      await this.stopSearching();

      this.searchBeacon({
        beacon: {
          uuid: this.currentPoi.beacons[0].uuid,
          identifier: this.currentPoi.beacons[0].identifier,
          major: this.currentPoi.beacons[0].major,
        }, //todo add poi's beacon
        poi: this.currentPoi,
      });
    },

    async previousPoi() {
      let i = 0;
      for (const poi of this.pois) {
        if (poi?.id == this.currentPoi?.id) {
          await this.setCurrentPoi(this.pois[i - 1].id);
          this.panTo(this.currentPoi.latitude, this.currentPoi.longitude);
          await this.stop();
          break;
        }

        i++;
      }
    },

    async nextPoi() {
      let i = 0;
      for (const poi of this.pois) {
        if (poi?.id == this.currentPoi?.id) {
          await this.setCurrentPoi(this.pois[i + 1].id);
          this.panTo(this.currentPoi.latitude, this.currentPoi.longitude);
          await this.stop();

          break;
        }

        i++;
      }
    },

    panTo(latitude, longitude) {
      this.$refs.mapRef.panTo({
        lat: latitude,
        lng: longitude,
      });
    },

    openDialog(poi, image, index) {
      this.dialog = {
        open: true,
        poi,
        image,
        index,
      };
    },

    closeDialog() {
      this.dialog = {
        open: false,
        poi: null,
        image: null,
        index: null,
      };
    },

    decodeEntities(description) {
      return decodeEntities(description);
    },

    async handlePlayer() {
      if (this.isPlaying) {
        await this.stop();
        return;
      }

      await this.play();
    },
  },
};
</script>

<style scoped lang="scss">
.chevron-button {
  border-top-right-radius: 10px !important;
}

.description {
  p {
    width: 100px;
    word-wrap: break-word;
  }
}

.content {
  position: fixed;
  top: 70px;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.content-title {
  position: fixed;
  top: -10px;
  // left: 50%;
  // transform: translate(-50%, -50%);
  color: #fed136;
}

.page-body {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

#wrapper {
  position: relative;
  z-index: 1000;
}
#return-button {
  position: absolute;
  top: 20px;
  left: 10px;
}

#map-controls {
  position: absolute;
  top: 20px;
  right: 10px;
}

#start-button {
}

.googleMap {
  width: 100%;
  height: calc(100vh);
}

.pulse-button {
  -webkit-animation: pulse-location 1.5s infinite;
  box-shadow: 0 0 0 8px rgba(#5a99d4, 0.5);
  border: 0.5px solid white;
}

.pulse-button:hover {
  -webkit-animation: none;
}

.inner {
  position: absolute;
  top: -5px;
  right: 20px;
  width: 80px;
  height: 80px;
  border: 10px solid var(--v-secondary-base);
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-items: center;
}

.pulse-button-start {
  -webkit-animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 0 var(--v-secondary-base);
}

@-webkit-keyframes pulse {
  0% {
  }
  70% {
    box-shadow: 0 0 0 15px rgba(90, 153, 212, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(90, 153, 212, 0);
  }
}
</style>
